import { useQuery } from '@hooks/reactQuery';

import { getAlarmsNoVesNetworkElements } from '@api/alarmManagement';

import { optionsFormattedWithIdName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { ALARM_CUSTOM_ALARMS_NETWORK_ELEMENTS } from '@constants/queryKeys';

interface IUseQueryCustomAlarmsNetworkElementsReturn {
	isLoadingAlarmsNoVesNetworkElements: boolean;
	noVesNetworkElementsOptions: TSelectOption[];
}

export const useQueryAlarmsNoVesNetworkElements = (): IUseQueryCustomAlarmsNetworkElementsReturn => {
	const {
		data,
		isInitialLoading: isLoadingAlarmsOran,
	} = useQuery({
		queryKey: [ALARM_CUSTOM_ALARMS_NETWORK_ELEMENTS],
		queryFn: getAlarmsNoVesNetworkElements,
		select: optionsFormattedWithIdName,
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingAlarmsNoVesNetworkElements: isLoadingAlarmsOran,
		noVesNetworkElementsOptions: data || [],
	};
};
